import * as React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardDescription } from "@/components/ui/card";
import styles from "./auth-page.module.css";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";
import { useAuthStore } from "@/store/auth/auth.store";
import { useNavigate } from "react-router";
import { Routes } from "@/router/routes";

import oidcConfig from "../../../oidc-client.config";

/**
 * The AuthPage component is the main component for the authentication page.
 * It displays a login form and a logo.
 */
export default function AuthPage() {
    const [t] = useTranslation();
    const auth = useAuth();
    const navigate = useNavigate();
    const redirectUrl = useAuthStore((state) => state.redirectUrl);

    console.log("oidcConfig", oidcConfig);

    // Handle successful authentication
    useEffect(() => {
        console.log("AuthPage - Auth State Changed:", {
            isAuthenticated: auth.isAuthenticated,
            redirectUrl,
            user: auth.user,
        });

        if (auth.isAuthenticated) {
            const targetUrl = redirectUrl || Routes.TenantSelection;
            useAuthStore.getState().clearRedirectUrl();
            navigate(targetUrl);
        }
    }, [auth.isAuthenticated, navigate, redirectUrl]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <Card className="w-full max-w-lg h-fit flex flex-col items-center justify-center gap-8 p-12">
                <CardHeader className="text-center flex justify-center items-center p-0">
                    <img src="/img/logo.svg" alt="Exibra CMS" className={styles.logo} />
                </CardHeader>
                <CardDescription className="text-center">
                    {t("auth.login.description")}
                </CardDescription>
                <div className="flex justify-center">
                    <Button
                        size="lg"
                        className="w-full max-w-xs"
                        onClick={() => {
                            auth.signinRedirect();
                        }}
                    >
                        {t("auth.login")}
                    </Button>
                </div>
            </Card>
        </div>
    );
}
